<template>
  <div style="background-color: #F9F9FB;width:100%">
    <div class="comicContent">
      <div :style="{display:isShowChapterNav ? 'block':'none'}">
        <div class="chapter" @click="handleChapter" style="top: 200px;margin-left: -634px;">
          <div class="chapter_img"><img  @dragstart.prevent  src="../assets/icon_zhangjie.png" alt=""></div>
          <p>章</p>
          <p>节</p>
        </div>
        <div class="chapter_open" id="chapterBox" v-show="isShowChapter" style="top: 200px;margin-left: -594px;">
          <div :class="[(item.chapterId == actChapter) ? 'chapter_act' : '', 'chapter_item flex-row-center']" v-for="(item) in allChapter" :key="item.chapterId"
            @click="changeChapter(item.unlockType,item.chapterId)" :id="`chapter_${item.chapterId}`">
            <span class="txtOverFlow1">{{ item.chapterName }}</span>
            <img  @dragstart.prevent  v-if="item.unlockType != 1" style="margin-left:4px" width="14px" src="../assets/icon_suohui.png" alt="">
          </div>
        </div>
      </div>
      <div class="chapter_header">
        <div class="header_left">
          <span @click="navTo('home')">首页-</span>
          <span @click="navToDetail(contentList.comicId)">{{contentList.comicName}}-</span>
          <span>{{contentList.chapterName	}}</span>
        </div>
        <div class="header_right">
          <span v-if="contentList.lastChapterId" @click="handleToOne(contentList.lastUnlockType,'last')">上一话</span>
          <span v-if="contentList.lastChapterId && contentList.nextChapterId">｜</span>
          <span v-if="contentList.nextChapterId" @click="handleToOne(contentList.nextUnlockType,'next')">下一话</span>
        </div>
      </div>
      <div class="chapter_comic" v-for="(item, index) in contentList.comicChapterItemList" :key="index"
        :style="{'width': `${width}px` }">
        <div class="img_box"><img  @dragstart.prevent  :src="item.realImgUrl" alt=""></div>
      </div>
      <div class="chapter_footer">
        <span v-if="contentList.lastChapterId" @click="handleToOne(contentList.lastUnlockType,'last')">上一话</span>
        <span v-if="contentList.lastChapterId && contentList.nextChapterId">｜</span>
        <span v-if="contentList.nextChapterId" @click="handleToOne(contentList.nextUnlockType,'next')">下一话</span>
      </div>
      <div class="toTop" style="margin-right: -664px;" id="reBack">
        <ul>
          <li @click="handleReback"><img  @dragstart.prevent  src="../assets/icon_goBack.png" alt=""></li>
          <li @click="handleGood">
            <img  @dragstart.prevent  v-if="contentList.likeType == 1" src="../assets/icon_detail_yidianzan.png" alt="">
            <img  @dragstart.prevent  v-else src="../assets/icon_dianzan.png" alt="">
          </li>
          <li @click="handlePay"><img  @dragstart.prevent  src="../assets/icon_fudai.png" alt=""></li>
          <li @click="handleAdd"><span>+</span></li>
          <li class="percentage"><span>{{ percentage }}%</span></li>
          <li @click="handleReduce"><span>-</span></li>
        </ul>
      </div>
    </div>
    	<buy-info-mode 
				v-if="isShowBuyInfoMode" 
				:singlePrice="contentList.singlePrice" 
				:buyInfoType="buyInfoType" 
				:userMoney="userMoney" 
				:checkAutoSub="checkAutoSub"
        :targetId="targetId"
				@changeCheckAutoSub="changeCheckAutoSub"
				@handleBtn="handleBtn" 
				@closeBuyInfoMode="()=>{isShowBuyInfoMode = false}"
			></buy-info-mode>
			<payModel 
        v-if="isshowPayModel" 
        :pay-list="payList" 
        :userMoney="userMoney"
        @closePayModel="()=>{isshowPayModel = false}" 
        @modelPay="modelPay" 
      ></payModel>
			<model-to-login 
        v-if="isShowLoginModel" 
        :errMsg="errMsg"
        @closeLoginModel="()=>{isShowLoginModel = false}"
      ></model-to-login>
  </div>
</template>

<script setup>
import {comicuserSingleLook, comicuserAllChapter, likeReadPoint, likeReadCancelPoint, rechargeRemain, gearGet, unlockChapter, switchAutoSub   } from '@/utils/api'
import { onMounted, ref, defineProps, watch } from 'vue';
import { useRouter,useRoute } from 'vue-router'
import { navTo, navToDetail, getUserInfo, payMoneyPublic, refreshUserInfo  } from '../utils/utils'
import payModel from "../components/payModel.vue"
import modelToLogin from "../components/modelToLogin.vue"
import buyInfoMode from "../components/buyInfoMode.vue"
	
const props = defineProps({
  loginstatus: Boolean,
});

let router = useRouter()
let route = useRoute()
let actChapter = ref(0)   //默认展示第章
let isShowChapter = ref(false)
let isShowChapterNav = ref(true)
let width = ref(800)
let contentList = ref([])
let timer = ref(null)
let percentage = ref(70)
let reBack = ref('')
let isShowBuyInfoMode = ref(false)
let isShowLoginModel = ref(false)
let userMoney = ref(0)
let buyInfoType = ref(0)
let checkAutoSub = ref(true)
let isshowPayModel = ref(false)
let payList = ref([])
let allChapter = ref([])
let targetId = ref(0)
let errMsg = ref('')
watch(() => route.query,
  (val) => {
      getSingleLook(val.chapterId)
      actChapter.value = val.chapterId
      isShowBuyInfoMode.value = false
      isShowLoginModel.value = false
      allChapter.value = []
      comicuserAllChapter({comicId:router.currentRoute.value.query.comicId}).then(res=>{
        allChapter.value = res.data
      })
  }
)
onMounted(()=>{
  let id = router.currentRoute.value.query.chapterId
  getSingleLook(id)
  comicuserAllChapter({comicId:router.currentRoute.value.query.comicId}).then(res=>{
    allChapter.value = res.data
    actChapter.value = id
  })
})
let keepPath=(chapterId)=>{
  localStorage.setItem('currPath',`/comicContent?comicId=${contentList.value.comicId}&chapterId=${chapterId}`)
}
// 点击某一章节
let	handleToOne = (unlockType,clicktype,chapterId)=>{
    let info = getUserInfo()
    let {lastChapterId,nextChapterId,singlePrice,vipStatus} = contentList.value
    let id = ''
    if(clicktype == 'last'){ //上一话
      id = lastChapterId
    }else if(clicktype == 'next'){ //下一话
      id = nextChapterId
    }else if(clicktype == 'zhangjie'){
      id = chapterId
    }
    targetId.value = id
    if( unlockType != 1 ){
      if(!props.loginstatus){
        // 没登陆不能看付费章节
        navTo('/login')
        keepPath(id)
      }else{
        if(vipStatus){
          // vip不弹弹窗
          unlockChapter({chapterId:id}).then(res=>{
            if(res.code == 200){
              // getSingleLook(id,true)
              navTo("/comicContent",{chapterId:id ,comicId:contentList.value.comicId})
            }else if(res.code == 2001){
              if(res.msg == '当前漫画已解锁，请勿重复解锁'){
                navTo("/comicContent",{chapterId:id ,comicId:contentList.value.comicId})
              }else{
                isShowLoginModel.value = true
                errMsg.value = res.msg
              }
            }
          }).catch(res=>{
            if(res.msg == '当前漫画已解锁，请勿重复解锁'){
                navTo("/comicContent",{chapterId:id ,comicId:contentList.value.comicId})
              }else{
                isShowLoginModel.value = true
                errMsg.value = res.msg
              }
          })
        }else{
          // 非vip，弹窗
          rechargeRemain().then(res=>{
            userMoney.value = res.data.remain
            if(info.autoSub == 0){
              isShowBuyInfoMode.value = true
            }
            // 判断钱都不够
            if(Number(res.data.remain)-Number(singlePrice)>=0){//钱够
              buyInfoType.value = 1
              if(info.autoSub == 1){//开了自动订阅
                handleBtn({val:0},id)
              }else{
                isShowBuyInfoMode.value = true
              }
            }else{//钱不够
              buyInfoType.value = 2
              isShowBuyInfoMode.value = true
            }
          })
        }
      }
    }else{
      // if(clicktype == 'last'){ //上一话
      //   getSingleLook(lastChapterId,true)
      // }else if(clicktype == 'next'){ //下一话
      //   getSingleLook(nextChapterId,true)
      // }else if(clicktype == 'zhangjie'){
      //   getSingleLook(chapterId,true)
      // }
      navTo("/comicContent",{chapterId:id ,comicId:contentList.value.comicId})
    }
  }
let getSingleLook = (chapterId,isBackTop) => { 
    contentList.value = []
  comicuserSingleLook({chapterId}).then(res=>{
    if(res.code == 200){
      contentList.value = res.data
      isBackTop ? handleReback() : ''
    }else if(res.code == 2001){
      if(res.msg == '当前漫画已解锁，请勿重复解锁'){
        navTo("/comicContent",{chapterId:chapterId ,comicId:contentList.value.comicId})
      }else{
        isShowLoginModel.value = true
        errMsg.value = res.msg
      }
    }
  }).catch(res=>{
    if(res.code == 2001){
      if(res.msg == '当前漫画已解锁，请勿重复解锁'){
        navTo("/comicContent",{chapterId:chapterId ,comicId:contentList.value.comicId})
      }else{
        isShowLoginModel.value = true
        errMsg.value = res.msg
      }
    }
  })
}
let modelPay=({index})=>{
  payMoneyPublic(payList.value[index].id,localStorage.getItem('currPath'))
}
let changeCheckAutoSub=()=>{
  checkAutoSub.value = !checkAutoSub.value
}
let changzChapter = (index => {
  actChapter.value = index
})

let handleChapter = () => {
  isShowChapter.value = !isShowChapter.value
  setTimeout(()=>{
      // 获取对应的目标元素位置
      var target = document.getElementById(`chapter_${actChapter.value}`);
      // var box = document.getElementById('chapterBox');
      var box = target.parentNode;
      var offsetTop = target.offsetTop;
      // 滚动到目标元素的位置
      box.scrollTo({
        top: offsetTop,
        behavior: 'auto' // 平滑滚动
      });
    })
}
let handleGood = () => { 
  let query = {
    chapterId: contentList.value.chapterId,
    comicId: contentList.value.comicId,
  }
  if(contentList.value.likeType == 1){
    contentList.value.likeType = 0
    likeReadCancelPoint(query).then(res=>{})
  }else{
    contentList.value.likeType = 1
    likeReadPoint(query).then(res=>{})
  }
}
let handleBtn=(obj,id)=>{
  let info = getUserInfo()
  if(obj.val == 2 || buyInfoType.value == 2 ){
    //充值按钮
    gearGet().then(res=>{
      payList.value= res.data
      isShowBuyInfoMode.value = false
      isshowPayModel.value = true
      keepPath(contentList.value.chapterId)
    })
    rechargeRemain().then(res=>{
      userMoney.value = res.data.remain
    })
    return
  }else if(buyInfoType.value == 1){
    //立即观看按钮
    unlockChapter({chapterId:id}).then(res=>{
      if((checkAutoSub.value && info.autoSub==0) || !checkAutoSub.value && info.autoSub==1){
        // 用户改了自动订阅状态
        switchAutoSub().then(()=>{
          refreshUserInfo()
        })
      }
      if(res.code == 200){
        navTo("/comicContent",{chapterId:id ,comicId:contentList.value.comicId})
      }else if(res.code == 2001){
        if(res.msg == '当前漫画已解锁，请勿重复解锁'){
          navTo("/comicContent",{chapterId:id ,comicId:contentList.value.comicId})
        }else{
          isShowLoginModel.value = true
          errMsg.value = res.msg
        }
      }
    }).catch(res=>{
      if(res.msg == '当前漫画已解锁，请勿重复解锁'){
          navTo("/comicContent",{chapterId:id ,comicId:contentList.value.comicId})
        }else{
          isShowLoginModel.value = true
          errMsg.value = res.msg
        }
    })
    return
  }
}
let changeChapter =(unlockType,val)=>{
  actChapter.value = val
  if(val != contentList.value.chapterId){
    handleToOne(unlockType,'zhangjie',val)
  }
}
let handleReback = () => {
  clearInterval(timer)
  timer = setInterval(() => {
    //设置返回顶部距离
    var top = document.documentElement.scrollTop
    //设置速度差距
    var v = Math.floor(-top / 5)
    document.documentElement.scrollTop = top + v
    //清除计时器
    if (top == 0) {
      clearInterval(timer)
    }
  }, 30)
}
window.addEventListener("scroll", function (e) {
  //变量scrollTop是滚动条滚动时，距离顶部的距离
  var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  //变量windowHeight是可视区的高度
  var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
  //变量scrollHeight是滚动条的总高度
  var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
  // console.log("距顶部" + scrollTop + "可视区高度" + windowHeight + "滚动条总高度" + scrollHeight);
  //滚动条到底部的条件
  if (scrollTop + windowHeight >= 4200) { //控制左侧章节导航
    isShowChapterNav.value = false
  } else {
    isShowChapterNav.value = true
  }
  try{
    if(document.getElementById('reBack')){
      let reBack = document.getElementById('reBack')
      if (scrollTop + windowHeight >= 1800) {   //返回顶部
        reBack.style.opacity = '1'
      } else {
        reBack.style.opacity = '0'
      }
    }
  }catch(err){
    console.log(err,'reBack报错')
  }
});
let handleAdd = () => {
  percentage.value += 10
  if(percentage.value>100){
    percentage.value=100
    return false
  }
  let v=(width.value)*0.1
  width.value += v
  
}
let handleReduce = () => {
  percentage.value -= 10
  if(percentage.value<50){
    percentage.value=50
    return false
  }
  let v=(width.value)*0.1
  width.value -= v
}
let handlePay=()=>{
  if(!props.loginstatus){
    // 没登陆先登录
    navTo('/login')
    keepPath( contentList.value.chapterId )
  }else{
    handleBtn({val:2})
  }
}

</script>

<style lang="scss" scoped>
.comicContent {
  width: 1188px;
  background: #FFF;
  border-radius: 10px;
  margin: 30px auto;
  padding-bottom: 30px;
  box-sizing: border-box;
  position: relative;


  .chapter {
    width: 40px;
    height: 100px;
    background: #FFFFFF;
    border-radius: 5px 0px 0px 5px;
    border: 1px solid #E6E6E6;
    text-align: center;
    padding: 10px 8px;
    box-sizing: border-box;
    font-size: 18px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;font-weight: lighter;
    color: #999999;
    line-height: 25px;
    cursor: pointer;
    position: fixed;
    left: 50%;
    z-index: 1;

    &_img {
      width: 22px;
      height: 22px;
      margin-bottom: 6px;
    }

    p {
      color: #999999;
    }
  }

  .chapter_open {
    width: 180px;
    // height: 327px;
    border-radius: 4px;
    border: 1px solid #E6E6E6;
    position: fixed;
    left: 50%;
    z-index: 1;
    padding: 0 10px;
    box-sizing: border-box;
    text-align: left;
    background-color: #FFFFFF;
    transition: all 0.5s ease;
    overflow: auto;
    max-height: 40%;

    .chapter_item {
      font-size: 14px;
      font-weight: 400;font-weight: lighter;
      color: #999999;
      line-height: 40px;
      border-bottom: 1px solid #E6E6E6;
      cursor: pointer;
      span{
        width: 140px;
      }
    }

    .chapter_act {
      color: #CB2945;
    }
  }

  .chapter_header {
    width: 100%;
    padding: 20px 30px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .header_left {
      font-size: 20px;
      font-weight: 400;font-weight: lighter;
      line-height: 40px;
      cursor: pointer;

      span:nth-child(1),
      span:nth-child(2) {
        color: #999999;
      }

      span:nth-child(3) {
        color: #333;
      }
    }

    .header_right {
      font-size: 20px;
      font-weight: 400;font-weight: lighter;
      line-height: 40px;

      span:nth-child(1) {
        color: #999999;
        cursor: pointer;
      }

      span:nth-child(2) {
        color: #999999;
      }

      span:nth-child(3) {
        color: #333;
        cursor: pointer;

      }
    }
  }

  .chapter_footer {
    width: 100%;
    height: 40px;
    font-size: 20px;
    font-weight: 400;font-weight: lighter;
    color: #999999;
    line-height: 40px;
    text-align: center;
    margin-top: 30px;

    span:nth-child(1) {
      color: #999999;
      cursor: pointer;
    }

    span:nth-child(2) {
      color: #999999;
    }

    span:nth-child(3) {
      color: #333;
      cursor: pointer;

    }
  }

  .toTop {
    width: 50px;
    position: fixed;
    right: 50%;
    z-index: 1;
    bottom: 5%;
    opacity: 0;
    transition: all .5s ease;

    li {
      width: 50px;
      height: 50px;
      background: #FFFFFF;
      border-radius: 6px;
      border: 1px solid #E6E6E6;
      margin-bottom: 12px;
      text-align: center;
      line-height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 23px;
      cursor: pointer;

      img {
        width: 30px;
        height: 30px;
      }

      &:hover {
        background: #E6E6E6;

      }
    }

    .percentage {
      font-size: 15px;

    }

  }

  .chapter_comic {
    height: auto;
    padding: 0 80px;
    box-sizing: border-box;
    margin: auto;
    width: 100%;
    transition: width .1s linear;

    .img_box {
      border: 0;
      margin: 0;
      padding: 0;
      width: 100%;

      img {
        width: 100%;
      }
    }

  }
}
</style>